import React, { createContext, useContext, useMemo, useState, useEffect } from 'react';
import { useStore } from '../../../../../../contexts/StoreContext';
import useSelectedProductSku from './hooks/useSelectedProductSku';
import useStoreAvailabilities from './hooks/useStoreAvailabilities';
import useProductSkus from './hooks/useProductSkus';

const StoreContext = createContext();

export function StoreProvider({ children, currentAttributeState }) {
  const { selectedStore } = useStore();
  const [stores, setStores] = useState(() => []);
  const skus = useProductSkus();
  const selectedSku = useSelectedProductSku(currentAttributeState);
  const { availabilities, fetchAvailabilities } = useStoreAvailabilities();

  useEffect(() => {
    if (selectedSku) {
      fetchAvailabilities(stores, [selectedSku]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stores, fetchAvailabilities]);

  useEffect(() => {
    if (selectedStore && skus.length > 0) {
      fetchAvailabilities([selectedStore], skus);
    }
  }, [selectedStore, skus, fetchAvailabilities]);

  const value = {
    availabilities,
    selectedSku,
    selectedStore,
    stores,
    setStores,
  };

  return <StoreContext.Provider value={value}>{children}</StoreContext.Provider>;
}

export function useStoreContext() {
  return useContext(StoreContext);
}
